module.exports = __webpack_public_path__ + "static/media/002ty@4x.20953603.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/002ty@4x.png
// module id = 409
// module chunks = 0 1